import React, { useState } from 'react';
import { Container, Col, Row, Modal, ModalBody } from 'reactstrap';
import './WirelessSharing.styles.css';

//Redux
import { useSelector, useDispatch } from 'react-redux';
import { selectWireless } from '../../redux/actions/optionActions';

//Images
import wireless from '../../assets/images/wireless.png';

//Components
import Header from '../Header/Header';
import Steps from '../Steps/Steps';
import SideMenu from '../SideMenu/SideMenu';

function WirelessSharing(props) {
  const dispatch = useDispatch();
  const toggleSide = useSelector(state => state.optionsReducer.toggleSide);
  const [showVideo, setShowVideo] = useState(false);
  const toggle = () => setShowVideo(!showVideo);

  const goToYourRoom = (opt, abrv) => {
    let obj = {
      name: opt,
      abre: abrv
    }
    dispatch(selectWireless(obj));
    props.history.push('/your-room');
  }

  return (
    <Container className="customContainer">
      <Header title={'Wireless Sharing'} showMobileMenu={true} />
      <Row>
        <Col xs="12" md="3"></Col>
        <Col xs="12" md="6" style={{textAlign: 'center'}} className="topWire">
          <Row>
            <Col xs="12" md="6">
              <img className="imgOps" src={wireless} alt=""/>
            </Col>
            <Col xs="12" md="6" className="centerWhite">
              <div className="contentDescriptionWire">
                <p className="mainText">What is wireless screen sharing?</p>
                <p className="secondText" style={{marginTop: 15}}>Wireless screen sharing allows you to project, or “mirror”, what is on your own device, and show it on the main screen without needing to use a cable. The screen will show a replica of what is displayed on your device (Smartphone, tablet, or computer).</p>
                <div className="rowIcons">
                  <div className="playIcon"></div>
                  <p className="playText" onClick={toggle}>{`Watch comparison video >`}</p>
                </div>
              </div>
            </Col>
          </Row>

          <Row style={{justifyContent: 'center'}}>
            <p className="secondSubtitle">Will your meeting members need to share content to the main screen wirelessly?</p>
            <div className="contentBtns">
              <div className="btnWhite" onClick={() => goToYourRoom('Yes', 'WY')}>
                <span className="txtBtn">Yes</span>
              </div>
            
              <div className="btnWhite" onClick={() => goToYourRoom('No', 'WN')}>
                <span className="txtBtn">No</span>
              </div>
            </div>
          </Row>

          <Row>
            <Steps active={6} />
          </Row>
        </Col>
        {toggleSide && <Col xs="12" md="3" className="slideMenuColWire" style={{paddingRight: 0}}>
          <SideMenu step={5} />
        </Col>}
      </Row>

      <Modal isOpen={showVideo} toggle={toggle} size="lg">
        <div className="closeIcon" onClick={toggle}>X</div>
        <ModalBody>
          <iframe width="100%" height="415" src="https://www.youtube.com/embed/AJ92rd5wTFQ" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        </ModalBody>
      </Modal>
    </Container>
  )
}

export default WirelessSharing;